import { EXTERNAL_LINKS } from "@/constants";
import { TRACKING_EVENT_NAMES } from "@/libs/tracking/events";
import { useTrackEvent } from "@/libs/tracking/useTrackEvent";
import { isAppleDevice } from "@/utils/isAppleDevice";
import { Button, ButtonText } from "@leplein/ui";
import { useTranslation } from "react-i18next";

interface Props {
	from?: string;
	evseId?: string;
}

export const DownloadAppButton = ({ from, evseId }: Props) => {
	const { t } = useTranslation("evse");
	const trackEvent = useTrackEvent();

	const handleOpenAppPress = () => {
		trackEvent(TRACKING_EVENT_NAMES.DOWNLOAD_APP_CLICK, { from, evseId });
		window.open(isAppleDevice() ? EXTERNAL_LINKS.APPSTORE_URL : EXTERNAL_LINKS.PLAYSTORE_URL, "_blank");
	};

	return (
		<Button size="lg" onPress={handleOpenAppPress}>
			<ButtonText>{t("footer.primaryCta")}</ButtonText>
		</Button>
	);
};
